import React from 'react'
import styled, { css } from 'styled-components'

import { useHtmlDir } from '@aboutyou/legacy-shared/src/LegacyWebCoreConfigContext'
import BadgeList from '@aboutyou/legacy-shared/src/ui/BadgeList/BadgeList'
import { BadgeListProps } from '@aboutyou/legacy-shared/src/ui/BadgeList/types'
import { useFeatureFlags } from 'store/context'
import ProductImage, { IProductImageProps } from './ProductImage'

type BadgesPosition = 'top-start' | 'bottom-start'

interface ProductImageModelInfo extends IProductImageProps {
  badgesPosition?: BadgesPosition
  badgesList: BadgeListProps
}

export const BadgesContainer = styled.div<{
  badgesPosition?: BadgesPosition
  $isRTL: boolean
}>`
  position: absolute;
  padding: 0;
  top: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${({ $isRTL }) =>
    $isRTL &&
    css`
      .sale {
        direction: initial;
      }
    `}

  transform: translateZ(0);
  left: 0;
  ${({ badgesPosition }) =>
    badgesPosition === 'bottom-start'
      ? css`
          top: auto;
          bottom: 20px;
        `
      : null};
  > li {
    margin-bottom: 5px;
    white-space: nowrap;
  }
`

const ProductImagesWithBadges: React.FC<ProductImageModelInfo> = ({
  badgesPosition,
  badgesList,
  ...props
}) => {
  const isRTL = useHtmlDir() === 'rtl'
  const { isActive: isFeatureFlagActive } = useFeatureFlags()
  const enablePriceDisplayOverhaul = isFeatureFlagActive(
    'enablePriceDisplayOverhaul',
  )

  return (
    <ProductImage {...props}>
      <BadgesContainer badgesPosition={badgesPosition} $isRTL={isRTL}>
        <BadgeList
          {...badgesList}
          shouldCombineSaleAndCampaignBadges={enablePriceDisplayOverhaul}
        />
      </BadgesContainer>
    </ProductImage>
  )
}

export default ProductImagesWithBadges
